<template>
  <div class="adver">
    <!-- 媒体选择 -->
    <div class="adver-con" v-if="dialogMediaVisible">
      <dl
        v-for="(item,index) in mediaOptions"
        :key="index"
        @click="actionAdver(item.model, item.value)"
      >
        <dt>
          <img :src="returnImg(item.model)" alt />
        </dt>
        <dd>{{item.label}}</dd>
      </dl>
    </div>
    <!-- 千川 -->
    <Qcadver
      v-if="media == 'QianChuan'"
      :info.sync="info"
      :media.sync="media"
      :dialogMediaVisible.sync="dialogMediaVisible"
    ></Qcadver>
    <!-- 快手 -->
    <Ksadver
      v-else-if="media == 'KuaiShou'"
      :info.sync="info"
      :media.sync="media"
      :dialogMediaVisible.sync="dialogMediaVisible"
    ></Ksadver>
    <!-- blibli -->
    <Bliadver
      v-else-if="media == 'BliBli'"
      :info.sync="info"
      :media.sync="media"
      :dialogMediaVisible.sync="dialogMediaVisible"
    ></Bliadver>
    <!-- Gdt -->
    <Gdtadver
      v-else-if="media == 'Gdt'"
      :info.sync="info"
      :media.sync="media"
      :dialogMediaVisible.sync="dialogMediaVisible"
    ></Gdtadver>
  </div>
</template>
<script>
// 引入公共组件供页面使用
import Qcadver from '@/components/adver/Qcadver.vue'
import Ksadver from '@/components/adver/Ksadver.vue'
import Bliadver from '@/components/adver/Bliadver.vue'
import Gdtadver from '@/components/adver/Gdtadver.vue'

export default {
  props: ['info'],
  components: {
    Qcadver,
    Ksadver,
    Bliadver,
    Gdtadver
  },
  data() {
    return {
      size: 'mini',
      dialogMediaVisible: false,
      media: '',
      mediaOptions: []
    }
  },
  methods: {
    returnImg(imgName) {
      return require('../../assets/images/' + imgName + '.png')
    },
    // 添加媒体
    actionAdver(model, mediaId) {
      //展示投放内容
      this.media = model
      //保存选中媒体
      localStorage.setItem('mediaId', mediaId)
      this.dialogMediaVisible = false
    },
    // 获取媒体信息
    getMediaInfo() {
      this.$api.get('release/getMediaInfo', {}, res => {
        if (res.code == 0) {
          this.mediaOptions = res.data
          if (res.data.length > 1) {
            this.dialogMediaVisible = true
          } else {
            //展示投放内容
            this.media = res.data[0]['model']
            //保存选中媒体
            localStorage.setItem('mediaId', res.data[0]['value'])
          }
        }
      })
    }
  },
  mounted: function() {
    this.getMediaInfo()
  }
}
</script>
<style lang="scss" scoped>
.adver {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .adver-con {
    display: flex;

    dl {
      width: 326px;
      height: 388px;
      border: 2px solid #fff;
      border-radius: 10px;
      background: #fff;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      margin: 0 30px;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        border: 2px solid #006aff;
        background: #ebf5ff;
      }

      dt {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
      }

      dd {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
      }
    }
  }
}
</style>
